import * as React from 'react';
import { Box } from '@material-ui/core';
import { Verifications } from './Verifications';
import { Link, QuickLinks } from './QuickLinks';

type Props = {
  links: Link[];
};

export const VerificationsQuickLinks: React.FC<Props> = ({ links }) => {
  return (
    <Box display="flex" gridGap={16}>
      <Verifications />
      <QuickLinks links={links} />
    </Box>
  );
};
